import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { FeatureFlagStrategy } from '../types';
import { useAliasedCustomizationFlag } from './use-aliased-customization-flag';

export const MESSAGING_AIR_CUSTOMIZATION_FLAGS = ['truelarkaimessaging', 'aimessaging'] as const;
const DEFAULT_ACTIVE_STATES = [State.ACTIVE, State.PROMOTE];

export const useMessagingAIRCustomizationFlag = (
  locationIds: string[],
  activeStates: State[] = DEFAULT_ACTIVE_STATES,
  strategy?: FeatureFlagStrategy
) => {
  return useAliasedCustomizationFlag(MESSAGING_AIR_CUSTOMIZATION_FLAGS, locationIds, activeStates, strategy);
};
